<template>
  <div class="password-page">
    <div class="title">修改密码</div>
    <div class="password-content">
      <div class="tips">温馨提示：密码修改成功后，需重新登录</div>
      <div class="type-title">选择类型</div>
      <div class="types">
        <span
          @click="changeType('password')"
          :class="['pointer type-item', type === 'password' ? 'type-item-active' : '']"
        >
          使用原密码修改
        </span>
        <span @click="changeType('phone')" :class="['pointer type-item', type === 'phone' ? 'type-item-active' : '']">
          使用验证码修改
        </span>
      </div>
      <div class="form-content">
        <el-form v-if="type === 'password'" ref="form" :rules="rules" :model="form" label-width="150px">
          <el-form-item prop="oldPasswoed" label="原密码">
            <el-input show-password v-model="form.oldPasswoed"></el-input>
          </el-form-item>
          <el-form-item prop="newPassWord" label="新密码">
            <el-input show-password v-model="form.newPassWord"></el-input>
          </el-form-item>
          <el-form-item prop="repeatPassword" label="确认新密码">
            <el-input show-password v-model="form.repeatPassword"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="border-radius:0" type="primary" @click="submitForm('form')">提交</el-button>
            <el-button style="border-radius:0">取消</el-button>
          </el-form-item>
        </el-form>
        <el-form v-else ref="formPhone" :rules="rulesPhone" :model="formPhone" label-width="150px">
          <el-form-item prop="mobile" label="手机号">
            <el-input maxlength="11" v-model="formPhone.mobile"></el-input>
          </el-form-item>
          <el-form-item class="verification" prop="code" label="验证码">
            <el-input v-model="formPhone.code"></el-input>
            <button class="btn-code" @click="isMobileUsed" v-if="getCodeBtn">获取验证码</button>
            <button class="btn-timer" v-else>{{ second }}秒</button>
          </el-form-item>
          <el-form-item prop="newPassWordPhone" label="新密码">
            <el-input show-password v-model="formPhone.newPassWordPhone"></el-input>
          </el-form-item>
          <el-form-item prop="repeatPasswordPhone" label="确认新密码">
            <el-input show-password v-model="formPhone.repeatPasswordPhone"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="border-radius:0" type="primary" @click="submitForm2('formPhone')">提交</el-button>
            <el-button style="border-radius:0">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
export default {
  data() {
    return {
      type: 'password',
      second: 60,
      getCodeBtn: true,
      form: {
        oldPasswoed: '',
        newPassWord: '',
        repeatPassword: ''
      },
      formPhone: {
        mobile: '',
        code: '',
        newPassWordPhone: '',
        repeatPasswordPhone: ''
      },
      rules: {
        oldPasswoed: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassWord: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        repeatPassword: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }]
      },
      rulesPhone: {
        mobile: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(Error('手机号码不能为空'));
              } else if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(Error('请输入正确的手机号'));
              } else {
                callback();
              }
            },
            required: true,
            trigger: 'blur'
          }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 6, message: '长度在 4 到 6 个字符', trigger: 'blur' }
        ],
        newPassWordPhone: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        repeatPasswordPhone: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }]
      }
    };
  },
  methods: {
    // 判断手机号码是否可用
    async isMobileUsed() {
      if (!/^1[3456789]\d{9}$/.test(this.form.mobile)) {
        this.$message('手机号码格式不正确');
        return;
      }
      this.sendCode();
    },
    // 发送验证码
    async sendCode() {
      const res = await api.login.getVerifyCode({
        mobile: this.mobile
      });
      if (res) {
        this.$message.success('验证码发送成功');
        this.getCodeBtn = false;
        let timer = setInterval(() => {
          if (this.second === 1) {
            clearInterval(timer);
            this.getCodeBtn = true;
            this.second = 60;
          }
          this.second--;
        }, 1000);
      }
    },
    changeType(val) {
      this.type = val;
      if (val === 'password') {
        this.$refs.formPhone.resetFields();
      } else {
        this.$refs.form.resetFields();
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          api.login.changePassword({
            oldPasswoed: this.form.oldPasswoed,
            newPassWord: this.form.newPassWord,
            repeatPassword: this.form.repeatPassword
          });
        } else {
          this.$message.success('error submit!!');
          return false;
        }
      });
    },
    submitForm2(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          api.login.changePassword({
            mobile: this.formPhone.mobile,
            code: this.formPhone.code,
            newPassWord: this.formPhone.newPassWord,
            repeatPasswordPhone: this.formPhone.repeatPasswordPhone
          });
        } else {
          this.$message.success('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.password-page {
  min-height: 539px;
  background-color: #ffffff;
  .title {
    padding-left: 24px;
    height: 42px;
    border-bottom: 1px solid #eeeeee;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .password-content {
    padding: 16px;
    .tips {
      height: 46px;
      background: #f6f9ea;
      font-size: 14px;
      font-weight: 400;
      color: #d8690b;
      line-height: 46px;
      padding-left: 16px;
    }
    .type-title {
      width: 676px;
      margin: 16px auto;
      padding-left: 150px;
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      line-height: 18px;
      margin-top: 16px;
    }
    .types {
      width: 676px;
      margin: 16px auto;
      padding-left: 150px;
      .type-item {
        display: inline-block;
        width: 184px;
        height: 32px;
        border: 1px solid #dedede;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 32px;
        margin-right: 8px;
        text-align: center;
        background-color: #fafafa;
      }
      .type-item-active {
        border: 1px solid #1e8dff;
        background-color: #ffffff;
        color: #1e8dff;
      }
    }
    .form-content {
      width: 676px;
      margin: 16px auto;
      .verification {
        position: relative;
      }
      .btn-code,
      .btn-timer {
        cursor: pointer;
        position: absolute;
        right: 0;
        width: 92px;
        height: 40px;
        border: 1px solid #dedede;
        text-align: center;
        line-height: 40px;
        color: #1e8dff;
        background-color: #ffffff;
      }
      .btn-timer {
        color: #1e8dff;
        background: #f7f7f7;
      }
    }
  }
}
</style>
